import React, { useRef, useState } from "react";
import toast from "react-hot-toast";
import * as api from "helper/helper";
import { useFormik } from "formik";
import LoadingButton from "../LoadingButton/LoadingButton";
import { withMask } from "use-mask-input";
import { onlyNumbers } from "helper/tools";

//    ref={(el) => (filtrosRef.current[index] = el)}

function ActualizarCreditoDispuesto({ item, reload }) {
  const filtrosRef = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const createMode = item == null || (item && Object.keys(item).length === 0);

  let initialValues = {
    id: 0,

    creditoDispuesto: 0,
  };

  if (!createMode) {
    initialValues = {
      creditoDispuesto: item.credito,
    };
  }

  const formik = useFormik({
    initialValues,
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    onSubmit: async (values, { props, setSubmitting }) => {
      /*const payload = {
                      creditoDispuesto: item.credito,
                    };*/

      const toastId = toast.loading("Actualizando Credito...");

      const creditoDisp = onlyNumbers(values.creditoDispuesto);
      let response = await api
        .updateCreditoDispuestoAsociado(item.id, creditoDisp)
        .catch((e) => {
          toast.dismiss(toastId);
          if (e.esError && e.codigoError && e.mensaje) {
            toast.error(`Error al Actualizar Credito. ${e.mensaje}`);
            //  setIsLoading(false);
            return;
          }
          toast.error("Error al Actualizar Credito.");
          //  setIsLoading(false);
        });

      //    setIsLoading(false);
      toast.dismiss(toastId);

      if (!response) return;

      toast.success("Credito Actualizado.");
      //    reloadOrdenes();
      if (reload) reload();

      filtrosRef.current.click();
    },
  });

  return (
    <>
      <div className="dropdown">
        <div
          ref={filtrosRef}
          className="dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          data-bs-auto-close="outside"
        >
          <i className="bi bi-three-dots"></i>
        </div>
        <div
          className="dropdown-menu"
          style={{ backgroundColor: "transparent" }}
        >
          <form
            onSubmit={(event) => {
              event.preventDefault();
            }}
          >
            <div className="form-control">
              <div className="col align-self-start mb-3">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Ajustar Credito Dispuesto
                </label>
                <input
                  ref={withMask("currency", {
                    groupSeparator: ",",
                    digits: 0,
                    numericInput: true,
                    rightAlign: false,
                    allowMinus: false,
                  })}
                  min="0"
                  max="400000"
                  className={`form-control `}
                  id="validationName"
                  aria-describedby="emailHelp"
                  value={formik.values.creditoDispuesto}
                  onChange={async (e) => {
                    const aValue = onlyNumbers(e.target.value);

                    formik.setFieldValue("creditoDispuesto", aValue);
                  }}
                />
                <div className="valid-feedback"></div>
                <div className="invalid-feedback"></div>
              </div>
              <div className="modal-footer" style={{ flexWrap: "nowrap" }}>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={(e) => {
                    //  formik.handleSubmit();
                    console.log(filtrosRef.current);

                    filtrosRef.current.click();
                  }}
                >
                  Cancelar
                </button>

                <LoadingButton
                  style={{ height: "38px" }}
                  onClick={async (e) => {
                    formik.handleSubmit();
                  }}
                  text={"Guardar"}
                  loadingText={"Guardando..."}
                  isLoading={isLoading}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default ActualizarCreditoDispuesto;
